import { FC } from 'react';
import { Link } from 'react-router-dom';
import { Flex, FlexProps } from '@chakra-ui/react';

import { OfferDetailsRouteState } from '../../../../types';

interface OfferCardLinkProps extends FlexProps {
  to: {
    pathname: string;
    state: OfferDetailsRouteState;
  };
}

const OfferCardLink: FC<OfferCardLinkProps> = (props) => (
  <Flex as={Link} {...props} />
);

export default OfferCardLink;
